import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography, useBreakpoints, useTheme } from '@monorepo/nova-ui';
import NotificationsErrorImage from '../assets/svg/notifications-error.svg?react';

export const NotificationsError: FC = () => {
  const { t } = useTranslation(['notificationCenter']);
  const { isMobile } = useBreakpoints();
  const { palette } = useTheme();

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      height={isMobile ? '100%' : '192px'}
      padding="16px"
      borderRadius="16px"
      sx={{ backgroundColor: palette.background.paper }}
    >
      <Box marginBottom="16px">
        <NotificationsErrorImage />
      </Box>
      <Typography fontSize={14} fontWeight={500}>
        {t('notificationCenter:we_tried_our_best')}
      </Typography>
      <Typography fontSize={14} fontWeight={500}>
        {t('notificationCenter:we_could_not_load_your_notification')}
      </Typography>
    </Box>
  );
};
